export enum Status {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}
